import {MachineGroup} from "../machine-group";

export class FirmwareFilters {
  serialNumbers: string[];
  machineModelUuids: string[];
  organizationName: string;
  machineGroups: MachineGroup[];
}
